function Footer() {//контакти
  return (
    <footer className="footer">

      <p>© 2026 My Portfolio</p>

      <a href="https://github.com/" target="_blank" rel="noopener noreferrer">
        GitHub
      </a>

    </footer>
  );
}

export default Footer;